import { apiClient } from './api'
import type { EntityType } from './comments'

export interface ActivityItem {
  id: number
  entity_type: EntityType
  entity_id: number
  action: string
  user_id?: number | null
  user?: { id: number; full_name?: string | null; email: string } | null
  metadata?: Record<string, unknown> | null
  created_at: string
}

export const activityService = {
  list: async (entityType: EntityType, entityId: number, limit = 100): Promise<ActivityItem[]> => {
    const { data } = await apiClient.get('/api/v1/activity/', {
      params: { entity_type: entityType, entity_id: entityId, limit },
    })
    return data
  },
}
